module.exports = __webpack_public_path__ + "static/media/rosephoto.1b70d77a.jpg";